module.exports = __webpack_public_path__ + "static/media/arch-14.29910e62.jpg";